import React, { useState } from "react";
import Notification from "../../../features/notification/Notification";
import { UncontrolledPopover, PopoverHeader, PopoverBody } from "reactstrap";
import "./NavBar.css";
import { selectCurrentUser, logOut } from "../../../features/auth/authSlice";
import { useSelector, useDispatch } from "react-redux";
import ChangePassword from "../../common/ChangePassword/ChangePassword";
import { Link } from "react-router-dom";

const NavBar = () => {
  const user = useSelector(selectCurrentUser);
  const dispatch = useDispatch();

  const [modalOpen, setModalOpen] = useState(false);

  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };

  return (
    <div className="container-fluid p-0">
      <nav className="navbar navbar-expand-lg navbar-light bg-main p-0">
        <div className="container-fluid">
          <Link className="navbar-brand home-link" to="/home">
            Limelight - Order Tracker
          </Link>
          <div className="d-flex align-items-center">
            <Notification />
            <a className="avatar nav-link" id="navbarDropdownMenuLink">
              <img
                src={user.imageURL}
                width="35"
                height="35"
                className="border rounded-circle"
                style={{ cursor: "pointer" }}
              />
            </a>
            <UncontrolledPopover
              trigger="legacy"
              placement="bottom-end"
              target="navbarDropdownMenuLink"
              className=""
            >
              <PopoverBody className="user-details text-center">
                <div className="mb-3">
                  <p className="fw-bold mb-1" style={{ fontSize: "16px" }}>
                    {user.firstName} {user.lastName}
                  </p>
                  <p className="m-0 primary-text no-wrap">{user.email}</p>
                  <button className="link-gradiant" onClick={toggleModal}>
                    Change Password
                  </button>
                </div>
                <button
                  className="btn btn-gradient w-100 btn-logout"
                  onClick={() => dispatch(logOut(user))}
                >
                  Logout
                </button>
              </PopoverBody>
            </UncontrolledPopover>
            <ChangePassword modalOpen={modalOpen} toggleModal={toggleModal} />
          </div>
        </div>
      </nav>
    </div>
  );
};

export default NavBar;
